import {
  Alert,
  CircularProgress,
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { VerificationRepository } from "../repositories/VerificationRepository";
import moment from "moment";
import PdfViewer from "../common/PdfViewer";
import {
  BsCheck,
  BsCheckCircle,
  BsCheckCircleFill,
  BsXCircleFill,
} from "react-icons/bs";
import { ErrorMessageResolver } from "../common/ErrorMessageResolver";

export const Verification = ({}) => {
  const [data, setData] = useState(null);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { appEntryId } = useParams();

  useEffect(() => {
    if (appEntryId) {
      setLoading(true);
      VerificationRepository.verify(appEntryId)
        .then((res) => {
          console.log("Verification successful:", res.data);
          console.log(res.data);
          setPdfBlob(base64ToBlob(res.data.documentBase64));
          setData(res.data);
        })
        .catch((err) => {
          console.error("Verification failed:", err);
          setError(ErrorMessageResolver.resolve(err));
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [appEntryId]);

  const base64ToBlob = (base64) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: "application/pdf" });
  };

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{ mt: 4, mb: 3, textAlign: "center" }}>
          <Typography variant="h4">
            <b>Верификација на документ</b>
          </Typography>
        </Grid>
        {loading && (
          <Grid item xs={12} sx={{ textAlign: "center", mt: 4, mb: 4 }}>
            <CircularProgress />
          </Grid>
        )}
        {!loading && error && (
          <Grid item xs={12} sx={{ textAlign: "center", mt: 1, mb: 4 }}>
            <Paper sx={{ p: 4 }}>
              <Typography variant="h6" sx={{ mb: 1 }}>
                <BsXCircleFill
                  size={32}
                  color="#e03131"
                  style={{ verticalAlign: "middle", marginRight: 10 }}
                />{" "}
                Грешка при верификација
              </Typography>
            </Paper>
          </Grid>
        )}
        {!loading && data && (
          <>
            <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
              <Alert
                severity="success"
                variant="filled"
                sx={{ mb: 2 }}
                icon={false}
              >
                <Typography variant="h6">
                  <BsCheckCircleFill
                    color="white"
                    size={32}
                    style={{ verticalAlign: "middle", marginRight: 10 }}
                  />
                  Документот е валиден
                </Typography>
              </Alert>
              <Paper sx={{ p: 4 }}>
                <Table size="small" class="table-striped">
                  <TableBody>
                    <TableRow>
                      <TableCell>Датум на креирање</TableCell>
                      <TableCell>
                        {data?.dateCreated
                          ? moment(data.dateCreated).format(
                              "YYYY-MM-DD HH:mm:ss"
                            )
                          : "Не е достапно"}
                      </TableCell>
                    </TableRow>
                    {data?.signatures?.map((sig, index) => (
                      <>
                        <TableRow key={index}>
                          <TableCell colSpan={2}>
                            <b>Детали за дигитален потпис #{sig.fieldName}</b>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell width={200}>Име (Common Name)</TableCell>
                          <TableCell>{sig.commonName}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Subject DN</TableCell>
                          <TableCell>{sig.subjectDN}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Причина</TableCell>
                          <TableCell>{sig.reason}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Локација</TableCell>
                          <TableCell>{sig.location}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Верификуван</TableCell>
                          <TableCell>{sig.verified ? "Да" : "Не"}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Време на потпис</TableCell>
                          <TableCell>
                            {sig.signDate
                              ? moment(sig.signDate).format(
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              : "Не е достапно"}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Време на потпис (TSA)</TableCell>
                          <TableCell>
                            {sig.tsaDate
                              ? moment(sig.tsaDate).format(
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              : "Не е достапно"}
                          </TableCell>
                        </TableRow>
                      </>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </Grid>
            <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
              <Paper sx={{ p: 4 }}>
                {pdfBlob && <PdfViewer pdfBlob={pdfBlob} />}
              </Paper>
            </Grid>
          </>
        )}
      </Grid>
    </Container>
  );
};
